<app-error-page title="Unauthorized" [showActionButton]="false">
    <p>Your authorization has failed.</p>
    <p>Please try refreshing the page</p>
</app-error-page>
